import { StyleSheet } from 'aphrodite'

import list from './list'
import group from './group'

export default {
  list: StyleSheet.create(list),
  group: StyleSheet.create(group)
}



// WEBPACK FOOTER //
// ./src/components/Community/partials/GroupTable/style/ColorBlind/index.js